module.exports = __webpack_public_path__ + "img/blue_romb.1e16607e.png";